export default {
  // 页面标题
  'pages.log.rawIngestion.title': '上传报文',
  'pages.log.rawIngestion.subtitle':
    '客户端上行数据的原始到达记录(收包即落袋,含畸形/被拒载荷);可查原始报文、下载原文、重载进同步管道',

  // 列表列
  'pages.log.rawIngestion.column.receivedAt': '到达时间',
  'pages.log.rawIngestion.column.receivedAtRange': '到达时间区间',
  'pages.log.rawIngestion.column.batchNo': '批次号',
  'pages.log.rawIngestion.column.batchNo.placeholder': '精确匹配',
  'pages.log.rawIngestion.column.batchNo.copy': '复制批次号',
  'pages.log.rawIngestion.column.batchNo.copied': '已复制',
  'pages.log.rawIngestion.column.endpoint': '上行入口',
  'pages.log.rawIngestion.column.tenant': '租户',
  'pages.log.rawIngestion.column.store': '门店',
  'pages.log.rawIngestion.column.tenant.placeholder': '请选择租户(可搜索)',
  'pages.log.rawIngestion.column.store.placeholder': '请选择门店(可搜索)',
  'pages.log.rawIngestion.column.store.placeholderFirst': '请先选择租户',
  'pages.log.rawIngestion.column.device': '设备',
  'pages.log.rawIngestion.column.device.copy': '复制设备ID',
  'pages.log.rawIngestion.column.device.copied': '已复制',
  'pages.log.rawIngestion.column.size': '报文大小',
  'pages.log.rawIngestion.column.parseStatus': '处置状态',
  'pages.log.rawIngestion.column.rejectReason': '拒绝原因',
  'pages.log.rawIngestion.column.action': '操作',

  // 通用占位/提示
  'pages.log.rawIngestion.placeholder.select': '请选择',
  'pages.log.rawIngestion.tooltip.nameNotBackfilled': '名称未回填',

  // 上行入口选项
  'pages.log.rawIngestion.endpoint.orderBatch': '订单批',
  'pages.log.rawIngestion.endpoint.operationalBatch': '运营批',
  'pages.log.rawIngestion.endpoint.memberLogs': '会员日志',
  'pages.log.rawIngestion.endpoint.mallUpload': '商城上传',

  // 处置状态选项(英文与后端 enumPick 同源)
  'pages.log.rawIngestion.parseStatus.captured': '已收包',
  'pages.log.rawIngestion.parseStatus.accepted': '已受理',
  'pages.log.rawIngestion.parseStatus.rejected': '已拒绝',
  'pages.log.rawIngestion.parseStatus.error': '处理异常',

  // 操作
  'pages.log.rawIngestion.action.detail': '详情',
  'pages.log.rawIngestion.action.reload': '重载',
  'pages.log.rawIngestion.action.reload.confirmTitle': '重载确认',
  'pages.log.rawIngestion.action.reload.confirmDesc':
    '将取原始报文原样重放进同步管道(仅订单批/运营批可用),是否继续?',
  'pages.log.rawIngestion.action.reload.tip': '重放进同步管道(按批次号幂等)',
  'pages.log.rawIngestion.action.reload.unsupported': '该端点不支持重载',

  // 消息
  'pages.log.rawIngestion.msg.loadDetailFailed': '加载详情失败',
  'pages.log.rawIngestion.msg.reloadSuccess': '重载成功(新到达行 {id})',
  'pages.log.rawIngestion.msg.replayResponse': '重放响应:code={code} {msg}',
  'pages.log.rawIngestion.msg.unknownId': '未知',

  // 详情抽屉
  'pages.log.rawIngestion.drawer.title': '到达详情',
  'pages.log.rawIngestion.drawer.download': '下载原文',
  'pages.log.rawIngestion.drawer.loading': '加载中…',
  'pages.log.rawIngestion.detail.arrivalId': '到达ID',
  'pages.log.rawIngestion.detail.receivedAt': '到达时间',
  'pages.log.rawIngestion.detail.endpoint': '上行入口',
  'pages.log.rawIngestion.detail.tenant': '租户',
  'pages.log.rawIngestion.detail.store': '门店',
  'pages.log.rawIngestion.detail.posId': '设备ID',
  'pages.log.rawIngestion.detail.clientIp': '客户端IP',
  'pages.log.rawIngestion.detail.bodySize': '报文字节',
  'pages.log.rawIngestion.detail.parseStatus': '处置状态',
  'pages.log.rawIngestion.detail.sinkFile': '文件层定位',
  'pages.log.rawIngestion.detail.rejectReason': '拒绝原因',
  'pages.log.rawIngestion.detail.rawBody': '原始报文',
  'pages.log.rawIngestion.detail.copyTruncated':
    '复制预览段(已截断,全文请下载)',
  'pages.log.rawIngestion.detail.copyOriginal': '复制原始报文',
  'pages.log.rawIngestion.detail.copied': '已复制',
  'pages.log.rawIngestion.detail.truncatedTag': '超 64KB 已截断,全文请下载',
  'pages.log.rawIngestion.detail.binaryTag': '二进制载荷,请下载查看',
  'pages.log.rawIngestion.detail.noPreviewBinary': '二进制载荷无文本预览',
  'pages.log.rawIngestion.detail.noPreview':
    '无可预览原文(元数据行或文件已归档)',
};
